import type { HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './Typography.module.scss';

type HeadingProps = HTMLAttributes<HTMLHeadingElement>;

type DisplayProps = HeadingProps;

export const Display = ({ children, className, ...displayAttributes }: DisplayProps) => {
  return (
    <h1 className={clsx(styles.display, className)} {...displayAttributes}>
      {children}
    </h1>
  );
};

type HeadlineProps = HeadingProps;

export const Headline = ({ children, className, ...headlineAttributes }: HeadlineProps) => {
  return (
    <h2 className={clsx(styles.headline, className)} {...headlineAttributes}>
      {children}
    </h2>
  );
};

type TitleProps = HeadingProps;

export const Title = ({ children, className, ...titleAttributes }: TitleProps) => {
  return (
    <h3 className={clsx(styles.title, className)} {...titleAttributes}>
      {children}
    </h3>
  );
};

type BodyProps = HTMLAttributes<HTMLSpanElement>;

export const Body = ({ children, className, ...spanAttributes }: BodyProps) => {
  return (
    <span className={clsx(styles.content, className)} {...spanAttributes}>
      {children}
    </span>
  );
};
